import { GlAccordion, GlAccordionItem, GlSkeletonLoader, GlEmptyState } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import EMPTY_DISCUSSION_URL from '@gitlab/svgs/dist/illustrations/empty-state/empty-activity-md.svg';
import { isLoggedIn } from '~/lib/utils/common_utils';
import { s__, n__ } from '~/locale';
import DesignDisclosure from '~/vue_shared/components/design_management/design_disclosure.vue';
import { ACTIVE_DISCUSSION_SOURCE_TYPES } from '../constants';
import { extractDiscussions } from '../utils.js?vue3';
import updateActiveDiscussionMutation from '../graphql/client/update_active_design_discussion.mutation.graphql';
import DesignDiscussion from '../design_notes/design_discussion.vue?vue3';
import DesignNoteSignedOut from '../design_notes/design_note_signed_out.vue?vue3';
import DesignDescription from './design_description.vue?vue3';
export default {
    name: 'DesignSidebar',
    components: {
        DesignDescription,
        DesignDisclosure,
        DesignDiscussion,
        DesignNoteSignedOut,
        GlAccordion,
        GlAccordionItem,
        GlSkeletonLoader,
        GlEmptyState
    },
    inject: [
        'registerPath',
        'signInPath'
    ],
    props: {
        design: {
            type: Object,
            required: true
        },
        isLoading: {
            type: Boolean,
            required: true
        },
        isOpen: {
            type: Boolean,
            required: true
        },
        resolvedDiscussionsExpanded: {
            type: Boolean,
            required: true
        },
        markdownPreviewPath: {
            type: String,
            required: true
        },
        isCommentFormPresent: {
            type: Boolean,
            required: true
        },
        designVariables: {
            type: Object,
            required: true
        }
    },
    emits: [
        'delete-note-error',
        'resolve-discussion-error',
        'toggle-resolved-comments'
    ],
    data () {
        return {
            discussionWithOpenForm: ''
        };
    },
    computed: {
        isLoggedIn () {
            return isLoggedIn();
        },
        showDescriptionForm () {
            // user either has permission to add or update description,
            // or the existing description should be shown read-only.
            return !this.isLoading && (this.design.issue?.userPermissions?.updateDesign || Boolean(this.design.descriptionHtml));
        },
        discussions () {
            return this.design?.discussions ? extractDiscussions(this.design.discussions) : [];
        },
        unresolvedDiscussions () {
            return this.discussions.filter((discussion)=>!discussion.resolved);
        },
        unresolvedDiscussionsCount () {
            return n__('%d Thread', '%d Threads', this.unresolvedDiscussions.length);
        },
        resolvedDiscussions () {
            return this.discussions.filter((discussion)=>discussion.resolved);
        },
        hasResolvedDiscussions () {
            return this.resolvedDiscussions.length > 0;
        },
        resolvedDiscussionsTitle () {
            return `${this.$options.i18n.resolveCommentsToggleText} (${this.resolvedDiscussions.length})`;
        },
        isResolvedDiscussionsExpanded: {
            get () {
                return this.resolvedDiscussionsExpanded;
            },
            set (isExpanded) {
                this.$emit('toggle-resolved-comments', isExpanded);
            }
        }
    },
    methods: {
        handleSidebarClick () {
            this.updateActiveDesignDiscussion();
        },
        updateActiveDesignDiscussion (discussion) {
            if (discussion?.resolved) {
                return;
            }
            this.$apollo.mutate({
                mutation: updateActiveDiscussionMutation,
                variables: {
                    id: discussion?.notes[0].id,
                    source: ACTIVE_DISCUSSION_SOURCE_TYPES.discussion
                }
            });
        },
        updateDiscussionWithOpenForm (id) {
            this.discussionWithOpenForm = id;
        }
    },
    i18n: {
        resolveCommentsToggleText: s__('DesignManagement|Resolved threads'),
        newDiscussionText: s__(`DesignManagement|Click on the image where you'd like to add a new comment.`)
    },
    EMPTY_DISCUSSION_URL
};
